import React from 'react';
import { SvgIconProps } from '@mui/material';

import { SvgIcon } from '../svg-icon';

function Sidebar({ fill, stroke, ...props }: SvgIconProps): JSX.Element {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <rect x="4" y="4" width="6" height="16" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 5C2 3.9 2.9 3 4 3H20C21.1 3 22 3.9 22 5V19C22 20.1 21.1 21 20 21H4C2.9 21 2 20.1 2 19V5ZM19 19C19.55 19 20 18.55 20 18V6C20 5.45 19.55 5 19 5H5C4.45 5 4 5.45 4 6V18C4 18.55 4.45 19 5 19H19Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export { Sidebar };
